import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';

import { Checkbox, FormControlLabel } from '@mui/material';
import { ChangeEvent } from 'react';

type Props = {
  control: Control<any>;
  name: string;
  label: string;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export default function ControlledCheckbox({
  control,
  name,
  label,
  disabled = false,
  onChange
}: Props) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        return (
          <FormControlLabel
            disabled={disabled}
            label={label}
            control={
              <Checkbox
                {...field}
                checked={!!field.value}
                onChange={(event: ChangeEvent<HTMLInputElement>) => {
                  field?.onChange(event);
                  onChange?.(event);
                }}
              />
            }
          />
        );
      }}
    />
  );
}
